import { redirectToCheckoutService } from './redirect-to-checkout'
import { redirectService } from './redirect'
import { PageConfig } from '../../../models/pages'

export interface ServiceHandlerArgs {
  iframeId: string
  messageId: number
  payload: Record<string, unknown>
  sendSuccessResponse: (
    iframeId: string,
    messageId: number,
    payload?: Record<string, unknown>,
  ) => void
  sendErrorResponse: (iframeId: string, messageId: number, error: string) => void
  pageConfig: PageConfig
}

/**
 * Service handler function signature
 * All service handlers must implement this interface
 */
export type ServiceHandler = (args: ServiceHandlerArgs) => Promise<void> | void

/**
 * Service registry mapping service types to their handlers
 */
type ServiceRegistry = Record<string, ServiceHandler>

export const SERVICE_HANDLERS: ServiceRegistry = {
  REDIRECT_TO_CHECKOUT: redirectToCheckoutService,
  REDIRECT: redirectService,
} as const
